import { OrderItem } from './order';

export type ProductAdded = {
  orderItem?: OrderItem;
  status?: string;
};
